import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileTypePpt = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M14 3v4a1 1 0 0 0 1 1h4" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6" }),
		/* @__PURE__ */ _jsx("path", { d: "M11 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6" }),
		/* @__PURE__ */ _jsx("path", { d: "M16.5 15h3" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 15v6" })
	]
});
export default SvgFileTypePpt;
